export default "__VITE_ASSET__DP2g8FJk__"